import React, {Component} from 'react';
import styled from "styled-components"
import { Tag } from 'antd';

import {PRIMARY_COLOR, PRIMARY_GRAY, PRIMARY_TEXT_COLOR} from "../../constants/COLORS";

const HeaderContainer = styled.div`
  text-transform: uppercase;
  font-size: 3rem;
  font-family: Quicksand, sans-serif;
  font-weight: 500;
  color: ${PRIMARY_GRAY};
  //position: ${props => props.listView ? 'relative' : 'fixed'};
  position: relative;
  top: 0;
  left: 0;
  z-index: 9;
  box-sizing: border-box;
  

  margin: 0.7rem 4rem 1.6rem 0;
  
  //margin-left: ${props => props.listView ? '2rem' : '400px'};
  padding: 0 5rem;
  
  .ant-tag{
        position: absolute;
        top: 50%;
        transform: translateY(-55%);
        font-size: 1.5rem;
        padding: 0.7rem 1.3rem;
        right: 10vw;
  }
  .line{
    width: 60%;
    height: 6px;
    border-radius: 15px;
    background-color: ${PRIMARY_GRAY};
    margin-left: 2rem;
  }
  @media only screen and (max-width: 1250px){
    margin-left: 8rem;
    width: calc(100% - 12rem);
    padding: 0;
    .ant-tag{
     right: 5vw;
    }

  }
  @media only screen and (max-width: 800px){
    font-size: 2rem;
    .line{
      height: 4px;
    }
    .ant-tag{
      font-size: 1.1rem;
      padding: 0.2rem 1rem;  
      right: 0;
    }
  }
  @media only screen and (max-width: 600px){
    width: 100%;
    padding: 1.5rem 6rem;
    margin: 0;
    background-color: ${PRIMARY_COLOR};
    color: ${PRIMARY_TEXT_COLOR};
    position: fixed;
    .line{
      height: 3px;
          background-color: ${PRIMARY_TEXT_COLOR};
          border-color: ${PRIMARY_TEXT_COLOR};
    }
    .ant-tag{
      font-size: 0.8rem;
      padding: 0 7px;
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-55%);
    }
  }
  @media only screen and (max-width: 500px){
       font-size: 1.2rem;
       padding: 1.5rem 2rem 1.5rem 5rem;

    .line{

    }
  }
  
`

class CallHeader extends Component {
    render() {
        return (
            <HeaderContainer listView={this.props.listView}>
                {this.props.children}
                <div className={'line'}><></></div>
                {this.props.listView ?
                    null
                    :
                    this.props.active ?
                        this.props.taken ?
                            <Tag color={'blue'}>Folyamatban</Tag>
                            :
                            <Tag color={'volcano'}>Varakozik</Tag>
                        :
                        <Tag color={'red'}>Befejezett</Tag>
                }

            </HeaderContainer>
        );
    }
}

export default CallHeader;



